import React from 'react';
import { Container } from 'react-bootstrap';
import './Footer.css';
import { Link } from 'react-router-dom';

function Footer ()  {
    return (
        <div>
            <Container>
            <div class="row">
                <div class="col">
                <ul>
                    <li className='quick__link__heading'>
                    <img className='logo__img' src='images/nav_logo.png' alt='exam-time-logo'/> 
                    Quick Link</li>
                    <Link to="/About" className='footer__link__nav'>
                    <li className='quick__link'>
                        About
                    </li>
                    </Link>
                    <Link to="/Careers" className='footer__link__nav'>
                    <li className='quick__link'>
                        Careers
                    </li>
                    </Link>
                    <Link to="/Contact" className='footer__link__nav'>
                    <li className='quick__link'>
                        Contact
                    </li>
                    </Link>

                    <Link to="/GeneralQuestions" className='footer__link__nav'>
                    <li className='quick__link'>
                        FAQ
                    </li>
                    </Link>

                </ul>
                </div>

                <div class="col">
                <ul>
                    
                <br/>
                <Link to="SelectBranchP" className='footer__link__nav'>
                    <li className='quick__link'>
                        RTU previous year papers
                    </li>
                    </Link>
                <Link to="/SelectBranch" className='footer__link__nav'>
                <li className='quick__link'>Notes</li>
                </Link>
                <Link to="/SelectBranchB" className='footer__link__nav'>
                <li className='quick__link'>
                        Books
                    </li>
                </Link>
                </ul>
                </div>

                <div class="col">
                    <br/>
                    <Link className='footer__link__nav' to="https://resume-builder-55.netlify.app/">
                    <li className='quick__link'>Create Resume</li> </Link>
                    <Link to="/CollegeReviewF" className='footer__link__nav'>
                    <li className='quick__link'>College Rating</li>
                    </Link>
                </div>
            </div>

                <p className='made__with'>Made with ❤️ by a RTU Student based in <a href="https://piyushagarwal.netlify.app/images/photo_editing/jalmahal.avif">Jaipur </a></p>
                <Link to='Terms'>   
                    <p style={{textAlign:'center'}}>Terms & Conditions</p>
                </Link>
            </Container>
        </div>
    );
}

export default Footer;
